import React from "react";
import { Box, Card, CardContent, Skeleton, Stack } from "@mui/material";

interface DashboardCardSkeletonProps {
  title?: boolean;
  subtitle?: boolean;
  height?: string | number;
}

export const DashboardCardSkeleton: React.FC<DashboardCardSkeletonProps> = ({
  title = true,
  subtitle = true,
  height = "100%",
}) => {
  return (
    <Card
      sx={{
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "none",
        height: height,
      }}
    >
      <CardContent
        sx={{
          flex: 1,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          p: 3,
        }}
      >
        {(title || subtitle) && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              mb: 2,
              width: "100%",
              gap: 1,
            }}
          >
            {title && <Skeleton variant="text" width="60%" height={24} />}
            {subtitle && <Skeleton variant="text" width="40%" height={20} />}
          </Box>
        )}
        <Box
          sx={{
            flex: 1,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Box>
      </CardContent>
    </Card>
  );
};
